import { masterType } from "../type";
import {
  modeList,
  commonData,
  createModel,
  deleteModel,
  modelDirList,
  masterExcel,
  uploadExcel,
  masterColumnShowApi,
  downloadColumnNameApi
} from "../../api";
import { buildExcelSchema } from "utils/masterColExcelUtils";

export const modelListAction = () => async (dispatch) => {
  try {
    const { data } = await modeList({});
    const user = JSON.parse(localStorage.getItem("user"))
    const updatedModeList = data.data.map((val) => ({
      label: user.role === 'editor' ? val.name : val.model,
      value: val.model,
      modelId: val._id
    }));

    dispatch({
      type: masterType.GET_MODEL_LIST,
      payload: {
        data: updatedModeList,
      },
    });
  } catch (error) {


    dispatch({
      type: masterType.ERROR_MASTER,
      payload: error,
    });
  }
};

export const commonDataAction =
  (requestData, page_no, limit, modelId, modelData, modalFilterData) =>
    async (dispatch) => {
      try {
        const { data } = await commonData(requestData);

        const { totalcount, totalpages } = data;
        const modalDataToSet = data.data.length > 0 ? data.data[0] : modalFilterData;
       
        dispatch({
          type: masterType.GET_DATA,
          payload: {
            data: data.data,
            column: data.columnShownJson,
            pagination: {
              page_no,
              limit,
              totalPages: totalpages,
              totalCount: totalcount,
            },
            model: modelData,
            modelMasterId: modelId,
            modalFilterData: modalDataToSet,
          },
        });
        dispatch({
          type: masterType.ERROR_MASTER,
          payload: data.message,
        });
      } catch (error) {
        dispatch({
          type: masterType.ERROR_MASTER,
          payload: error,
        });
      }
    };

export const modelAddAction = (requestData) => async (dispatch) => {
  try {
    const { data } = await createModel(requestData);

    const user = JSON.parse(localStorage.getItem("user"));

    const updatedModeList = {
      label: user.role === 'editor' ? data.data.name : data.data.model,
      value: data.data.model,
      modelId: data.data._id
    };

    dispatch({
      type: masterType.ADD_MODEL,
      payload: {
        data: data,
        modeList: updatedModeList
      },
    });

   

  } catch (error) {
    const data = {
    status: error.response?.status || 500,
    message: error.response?.data?.message || error.message || "Unexpected error occurred",
  };

   dispatch({
      type: masterType.ERROR_MASTER,
      payload: {data:data},
    });
  }
};


export const modelDeleteAction = (modelId) => async (dispatch) => {
  try {
    const { data } = await deleteModel(modelId);

    dispatch({
      type: masterType.DELETE_MODEL,
      payload: {
        data: data,
        modelMasterId: modelId,
      },
    });
  } catch (error) {
    
    dispatch({
      type: masterType.ERROR_MASTER,
      payload: error,
      
    });
  }
};

export const modelDirListAction = () => async (dispatch) => {
  try {
    const { data } = await modelDirList();

    const updatedModeDirList = data.data.map((val) => ({
      label: val,
      value: val,
    }));

    dispatch({
      type: masterType.MODEL_LIST,
      payload: { data: updatedModeDirList },
    });
  } catch (error) {
    dispatch({
      type: masterType.ERROR_MASTER,
      payload: error,
    });
  }
};

export const loadingMasterAction =
  (toggle = true) =>
    (dispatch) => {
      dispatch({
        type: masterType.LOADING_MASTER,
        payload: toggle,
      });
    };

export const dataSearchAction = (reqBody) => async (dispatch) => { };

export const excelDownloadAction =
  (reqBody, keys, skip, frontendFilter, findsubareaId) => async (dispatch) => {

    try {
      const response = await masterExcel({
        model: reqBody.value,
        keys: keys,
        skip: skip,
        limit: 4000,
        frontendFilter,
        findsubareaId
      });

      const fullPath = response.data.fileName; // Assuming `fileName` holds the full path

      dispatch({
        type: masterType.DOWNLOAD_EXCEL,
        payload: { data: fullPath },
      });
    } catch (error) {

      dispatch({
        type: masterType.ERROR_MASTER,
        payload: error,
      });
    }
  };

export const excelUploadAction = (reqBody) => async (dispatch) => {
  try {
    const response = await uploadExcel(reqBody);

    dispatch({
      type: masterType.UPLOAD_EXCEL,
      payload: { data: response?.data.message, count: response?.data.Modified },
    });
  } catch (error) {

    dispatch({
      type: masterType.ERROR_MASTER,
      payload: { data: error.response.data.error },
    });
  }
};


export const columnShownUploadAction = (formData) => async (dispatch) => {
  try {
    const res = await masterColumnShowApi(formData);
    console.log('res----',res)
    dispatch({
      type: masterType.UPLOAD_COLUMN_NAME_EXCEL,
      payload: {
        data: res?.data.message || "Upload success",
        count: res?.data.Modified || 0,
      },
    });
  } catch (err) {
    dispatch({
      type: masterType.ERROR_MASTER,
      payload: { data: err?.response?.data?.error || "Upload failed" },
    });
  }
};

export const downloadColumnNameAction = (masterName, commonData) => async (dispatch) => {
 
  try {
    const response = await downloadColumnNameApi(masterName?.value); // Pass only the value
 
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${masterName?.label || 'column-data'}.xlsx`);

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("File download failed", error.response.status);
       
    if(error.response.status === 404) buildExcelSchema(commonData, masterName)
  }
};

export const resetMasterMessage = () => ({
  type: masterType.RESET_MASTER_MESSAGE,
});
